import { render, staticRenderFns } from "./BaseMoneyInput.vue?vue&type=template&id=80c4ea32"
import script from "./BaseMoneyInput.vue?vue&type=script&lang=js"
export * from "./BaseMoneyInput.vue?vue&type=script&lang=js"
import style0 from "./BaseMoneyInput.vue?vue&type=style&index=0&id=80c4ea32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports